export default __webpack_public_path__ + "static/first-of-the-year-0076ea2746d66046a7cde65b3fa575af.svg";